import React from "react";
import PropTypes from "prop-types";

/**
 * Componente TabList
 *
 * @component
 * @param {Object} props - As propriedades do componente.
 * @param {ReactNode} props.children - O conteúdo a ser renderizado dentro do wrapper de abas.
 * @returns {ReactElement} O elemento React renderizado que representa o wrapper de abas.
 */
function TabList({ children }) {
  return (
    <ul
      className="nav nav-pills col-md-12 mb-3"
      role="tablist"
      style={{ gap: "12px" }}
    >
      {children}
    </ul>
  );
}

TabList.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TabList;
